<template>
  <div
    :class="['relative', { 'full-height': isFullHeight }]"
    :id="'MapVue' + Math.random()"
  >
    <div
      v-if="loading"
      style="
        position: absolute;
        z-index: 4;
        top: 20px;
        left: 20px;
        opacity: 0.7;
      "
    >
      <Loader />
    </div>
    <GMapMap
      class="gmap"
      @bounds_changed="updateVisibleMarkers"
      @click="getAddressFromCords($event)"
      ref="gmap"
      :zoom="zoom"
      :style="styles"
      :options="mapOptions"
    >
      <GMapPolygon
        v-if="isMoscowZone"
        :paths="mskPoly"
        :editable="false"
        :options="polyOptions"
        @click="getAddressFromCords($event)"
      >
      </GMapPolygon>
      <GMapPolygon
        v-if="isMoscowZone"
        :paths="msk1Poly"
        :editable="false"
        :options="polyOptions"
        @click="getAddressFromCords($event)"
      >
      </GMapPolygon>
      <GMapPolygon
        v-if="isMoscowZone"
        :paths="msk2Poly"
        :editable="false"
        :options="polyOptions"
        @click="getAddressFromCords($event)"
      >
      </GMapPolygon>
      <GMapPolygon
        v-if="city === 'Київ'"
        :paths="kievPoly"
        :editable="false"
        :options="polyOptions"
        @click="getAddressFromCords($event)"
      >
      </GMapPolygon>
      <GMapPolygon
        v-if="city === 'Санкт-Петербург'"
        :paths="spbPoly"
        :editable="false"
        :options="polyOptions"
        @click="getAddressFromCords($event)"
      >
      </GMapPolygon>
      <GMapCluster
        v-if="showMarkers"
        :zoom-on-click="true"
        :styles="clusterStyles"
        :minimumClusterSize="4"
      >
        <GMapMarker
          v-for="(marker, idx) in showedMarkers"
          :key="idx"
          :position="marker.position"
          :clickable="true"
          :draggable="false"
          :icon="getMarkerIcon(marker)"
          @click="showPickpointInfo(marker)"
        >
        </GMapMarker>
      </GMapCluster>
    </GMapMap>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import { mapMutations } from 'vuex'
import { polygons, courierMskZone } from '@/utils/polygons'
// eslint-disable-next-line no-undef
import mapMarker from '@/assets/img/map-marker.png'
// eslint-disable-next-line no-undef
import mapMarkerBlue from '@/assets/img/map-marker-blue.png'
import I_FIVEPOST from '@/assets/img/5post.png'
import I_SDEK_P from '@/assets/img/sdek.png'

import activeMarker from '@/assets/img/active-marker.png'
import { normalizeString } from '@/utils/pickpoints'
import debounce from 'lodash/debounce'

const mapClusterImg =
  'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjAgNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjI2LjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNGRjU4NUQiIHN0cm9rZS13aWR0aD0iNyIvPgo8L3N2Zz4K'

export default {
  name: 'MapGoogle',
  props: {
    styles: String,
    initialMarkers: Array,
    centerMapToCoords: Object,
    mapOptions: Object,
    zoomToCords: Object,
    getAddressOnClick: Boolean,
    addressToGetCords: String,
    initialZoom: Number,
    showMarkers: {
      type: Boolean,
      default: true,
    },
    city: {
      type: String,
      default: '',
    },
    filterMarkersByCity: {
      type: String,
      default: '',
    },
    isFullHeight: {
      type: Boolean,
      default: false,
    },
    activePickpoint: {
      type: Object,
      default: () => {},
    },
    needDefaultZoom: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Loader,
  },
  data() {
    return {
      loading: false,
      zoom: null,
      markers: [],
      zoomout: false,
      maxMarkers: 150,
      showedMarkers: [],
      defaultZoom: 10,

      activeMarkerOptions: {
        url: activeMarker,
        size: { width: 26, height: 26, f: 'px', b: 'px' },
        scaledSize: { width: 26, height: 26, f: 'px', b: 'px' },
      },
      markerOptions: {
        url: mapMarker,
        size: { width: 60, height: 60, f: 'px', b: 'px' },
        scaledSize: { width: 60, height: 60, f: 'px', b: 'px' },
      },
      markerOptionsUa: {
        url: mapMarkerBlue,
        size: { width: 60, height: 60, f: 'px', b: 'px' },
        scaledSize: { width: 60, height: 60, f: 'px', b: 'px' },
      },
      I_FIVEPOST: {
        url: I_FIVEPOST,
        size: { width: 28, height: 40, f: 'px', b: 'px' },
        scaledSize: { width: 28, height: 40, f: 'px', b: 'px' },
      },
      I_SDEK_P: {
        url: I_SDEK_P,
        size: { width: 35, height: 45, f: 'px', b: 'px' },
        scaledSize: { width: 35, height: 45, f: 'px', b: 'px' },
      },
      clusterStyles: [
        {
          textColor: 'black',
          url: mapClusterImg,
          height: 40,
          width: 40,
        },
        {
          textColor: 'black',
          url: mapClusterImg,
          height: 50,
          width: 50,
        },
        {
          textColor: 'black',
          url: mapClusterImg,
          height: 60,
          width: 60,
        },
      ],
      polyOptions: {
        strokeColor: '#FA5F55',
        strokeOpacity: 1.0,
        strokeWeight: 3.0,
        fillColor: '#FA5F55',
        fillOpacity: 0.1,
      },
    }
  },
  computed: {
    isMoscowZone() {
      if (this.city === 'Москва') return true
      if (this.$store.state.defaultLocation) {
        return !!courierMskZone(this.$store.state.defaultLocation)
      }
      return false
    },
    mskPoly() {
      return polygons.moscow.paths
    },
    msk1Poly() {
      return polygons.moscow1.paths
    },
    msk2Poly() {
      return polygons.moscow2.paths
    },
    kievPoly() {
      return polygons.kiev.paths
    },
    spbPoly() {
      return polygons.piter.paths
    },
    field_filterPickpoints() {
      return this.$store.state.field_filterPickpoints
    },
  },
  watch: {
    initialMarkers: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (!oldValue || newValue.length != oldValue.length) {
            // без этого google map не собирает корректно кластер
            window.setTimeout(() => {
              if (newValue.length > 0) this.generateBounds()
              this.showedMarkers = this.sliceRandomMarkers(newValue)
            }, 0)
          }
        }
      },
    },
    zoomToCords: {
      handler(newValue) {
        if (newValue.lat && newValue.lng) {
          this.zoomMapToCords(newValue)
        } else {
          this.generateBounds()
        }
      },
      deep: true,
    },
    centerMapToCoords: {
      handler(value) {
        if (this.$refs.gmap && value && Object.keys(value).length) {
          setTimeout(() => {
            this.$refs.gmap?.$mapPromise?.then((map) => {
              map.setCenter(value)
            })
          }, 300)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.markers = this.initialMarkers;
    this.updateVisibleMarkers()
    if (this.addressToGetCords) {
      this.getCordsFromAddress(this.addressToGetCords)
    }
    // в случае редактирования профиля доставки, нужно зумить сразу к адресу, эта логика лишняя, получается
    if (!this.addressToGetCords) {
      this.zoom = this.initialZoom
      this.generateBounds()
    }
  },
  methods: {
    ...mapMutations(['updateDefaultLocation']),
    updateVisibleMarkers: debounce(function () {
      if (!this.$refs.gmap || this.city.length > 0) return
      this.$refs.gmap.$mapPromise.then((map) => {
        const bounds = map.getBounds()
        if (!bounds) return
        const normalizedSearch = normalizeString(
          this.field_filterPickpoints.toLowerCase()
        )

        // Фильтр по поиску или по границам карты
        let markers =
          this.field_filterPickpoints.length > 0
            ? this.filterMarkersBySearch(normalizedSearch)
            : this.filterMarkersByBounds(map, bounds)

        // Фильтр по городу при зуме меньше defaultZoom
        if (map.getZoom() < this.defaultZoom && this.filterMarkersByCity) {
          const normalizedFilterCity = normalizeString(
            this.filterMarkersByCity.toLowerCase()
          )
          markers = markers.filter((marker) => {
            const normalizedMarkerCity = normalizeString(
              marker.CITY.toLowerCase()
            )
            return normalizedMarkerCity.includes(normalizedFilterCity)
          })
        }
        this.showedMarkers = markers
      })
    }, 250),

    filterMarkersBySearch(lowerValue) {
      const filteredMarkers = this.initialMarkers.filter(
        ({ ADDRESS, NAME, EMAIL }) =>
          [ADDRESS, NAME, EMAIL].some(
            (field) => field && field.toLowerCase().includes(lowerValue)
          )
      )
      return this.sliceRandomMarkers(filteredMarkers)
    },
    filterMarkersByBounds(map, bounds) {
      this.maxMarkers = this.calculateMaxMarkers(map.getZoom())
      const filteredMarkers = this.initialMarkers.filter(
        ({ position: { lat, lng } }) => {
          // eslint-disable-next-line no-undef
          const position = new google.maps.LatLng(lat, lng)
          return bounds.contains(position)
        }
      )
      return this.sliceRandomMarkers(filteredMarkers)
    },
    calculateMaxMarkers(zoom) {
      if (zoom > 15) return this.initialMarkers.length
      if (zoom > 10) return 250
      return 150
    },

    async getAddressFromCords(event) {
      if (this.getAddressOnClick) {
        let cords = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        }
        this.updateDefaultLocation(event.latLng)
        // eslint-disable-next-line no-undef
        let geocoder = new google.maps.Geocoder()
        this.loading = true
        await geocoder.geocode(
          {
            latLng: cords,
          },
          (results, status) => {
            // eslint-disable-next-line no-undef
            if (status == google.maps.GeocoderStatus.OK) {
              if (
                results[0] &&
                (this.initialMarkers === null || this.initialMarkers.length < 2)
              ) {
                this.zoomout = true
                this.$emit('get-address-info', results[0])
              }
              this.loading = false
            } else console.log('Error getting address.')
          }
        )
      }
    },
    async getCordsFromAddress(address) {
      if (this.getAddressOnClick) {
        let marker = {
          position: {
            lat: 0,
            lng: 0,
          },
        }
        this.$gmapApiPromiseLazy().then(() => {
          // eslint-disable-next-line no-undef
          let geocoder = new google.maps.Geocoder()
          geocoder.geocode(
            {
              address: address,
            },
            (results, status) => {
              // eslint-disable-next-line no-undef
              if (status == google.maps.GeocoderStatus.OK) {
                marker.position.lat = results[0].geometry.location.lat()
                marker.position.lng = results[0].geometry.location.lng()
                if (marker.position.lat && marker.position.lng) {
                  this.markers = []
                  this.markers.push(marker)
                  this.zoomMapToCords({
                    lat: marker.position.lat,
                    lng: marker.position.lng,
                  })
                }
              } else console.log('Error getting cords.')
            }
          )
        })
      }
    },
    generateBounds() {
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line no-undef
        let bounds = new google.maps.LatLngBounds()
        if (this.showedMarkers && this.showedMarkers.length) {
          this.showedMarkers.forEach((marker) => {
            if (marker.position.lat && marker.position.lng) {
              bounds.extend(
                // eslint-disable-next-line no-undef
                new google.maps.LatLng(marker.position.lat, marker.position.lng)
              )
            }
          })
          if (!this.zoomToCords.lat || !this.zoomToCords.lng) {
            map.fitBounds(bounds)
            let zoom = map.getZoom()
            if (!this.zoomout) {
              map.setZoom(zoom > this.defaultZoom ? this.defaultZoom : zoom)
            } else {
              this.zoomout = false
            }
          } else {
            setTimeout(() => {
              if (!this.zoomout) {
                map.setZoom(this.defaultZoom)
              } else {
                this.zoomout = false
              }
            }, 1000)
          }
        } else {
          map.panTo(this.$store.state.defaultLocation)
        }
      })
    },
    showPickpointInfo(pickpointData) {
      this.$emit('show-pickpoint-info', pickpointData)
    },
    zoomMapToCords(cordsObj) {
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line no-undef
        let bounds = new google.maps.LatLngBounds()
        bounds.extend(
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(cordsObj.lat, cordsObj.lng)
        )
        // если пришло дефолтное значение с глобальной карты, то не исполняем fitbounds, иначе происходит ненужный зум
        if (
          cordsObj.lat !== 44.50397320941705 &&
          cordsObj.lng !== -38.40484544334248
        ) {
          map.fitBounds(bounds)
        }
        let zoom = map.getZoom()
        if (
          (this.showedMarkers && this.showedMarkers.length >= 1) ||
          this.addressToGetCords
        ) {
          if (!this.zoomout) {
            map.setZoom(zoom > this.defaultZoom ? this.defaultZoom : zoom)
          } else {
            this.zoomout = false
          }
        }
        if (this.needDefaultZoom) {
          setTimeout(() => {
            map.setZoom(this.defaultZoom)
          }, 1000)
        }
      })
    },
    sliceRandomMarkers(markers) {
      if (!markers || markers.length === 0) return []
      const shuffled = [...markers]

      // тасуем по алгоритму Фишера–Йетса
      for (let i = shuffled.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1))
        ;[shuffled[i], shuffled[randomIndex]] = [
          shuffled[randomIndex],
          shuffled[i],
        ]
      }

      return shuffled.slice(0, this.maxMarkers)
    },
    getMarkerIcon(marker) {
      if (this.activePickpoint?.CODE === marker.CODE && this.activePickpoint)
        return this.activeMarkerOptions
      else {
        switch (marker.TYPE) {
          case 'I_PICKUP':
            return this.markerOptionsUa
          case 'I_FIVEPOST':
            return this.I_FIVEPOST
          case 'I_SDEK_P':
            return this.I_SDEK_P
          default:
            return this.markerOptions
        }
      }
    },
  },
}
</script>

<style>
.vue-map {
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  overflow: hidden;
  border-radius: 8px;
}

.vue-map-container {
  height: 0 !important;
  padding-top: 55.39%;
  overflow: hidden;
}

@media screen and (max-width: 1023px) {
  .vue-map-container {
    padding-top: 0;
    height: 90vw !important;
  }
}
.full-height {
  height: 100% !important;
  z-index: 1;
}
.gmnoprint div {
  border-radius: 6px !important;
}
</style>
